/**
 * Additional styling for the cookie-bar for a smaller appearance
 * @constructor
 */
function StyleCCBar() {
    const css = `
        #ccm_notification #ccm_notification_wrapper { 
            padding: 20px 30px 10px;
        }
        #ccm_notification #ccm_col_content_regular h3 {
            font-size: 20px;
            margin-bottom: 4px;
        }
        #ccm_notification #ccm_notification_content {
            padding: 0 0 0 145px;
        }
        #ccm_notification #ccm_col_content_regular {
            margin-bottom: 10px;
        }
        #ccm_notification #ccm_col_content_regular a {
            font-size: 14px;
        }
        #ccm_notification #ccm_col_content_regular p {
            font-size: 14px;
            margin-bottom: 6px;
        }
        #ccm_notification .ccm_col_content_cookieitem-info {
            font-size: 14px
        } 
        #ccm_notification .ccm_col_content_cookieitem-radiocheck {
            height: 40px;
            width: 40px;
        }
        #ccm_notification #ccm_col_content_cookieitems-list li {
            padding: 8px 0;
        }
        #ccm_notification .ccm_col_content_cookieitem-radiowrap label:first-of-type svg {
            margin-top: 12px
        }
        #ccm_notification .ccm_col_content_cookieitem-radiocheckicon {
            margin-top: 11px
        }
        #ccm_notification #ccm_col_content_footer {
            margin-top: 10px;
        }
        #ccm_notification #ccm_col_content_cookieitems-list li:first-of-type {
            border: 0;
        }
        #ccm_notification #ccm_col_content_cookieitems-list li:last-of-type {
            border-bottom: 0;
        }
        #ccm_notification #ccm_col_content_footer .ccm_btn {
            width: auto;
            padding: 11px 15px;
        }
        @media only screen and (max-width: 375px){
            #ccm_notification .ccm_col_content_cookieitem-info {
                width: 100%;
            }
        }`;
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.type = 'text/css';
    if (style.styleSheet) {
        style.styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);
}

function AllowCookie(type) {
    const value = typeof (ccm) === "object" && ccm.getCategoryConsent(type);

    return value === null ? false : value;
}

function GetPermissions() {
    return ccm.get_permissions();
}

function ShowCC() {
    $('html, body')
        .scrollTop(0)
            .find('body')
                .addClass('has--ccm-visible')
                .queue(function() {
                    // check if ccm is loaded and ccm banner not visible
                    if (!(typeof window.ccm !== undefined && window.ccm.has_banner())) {
                        window.ccm.showCookieMessageBar();
                    }
                });
}

/**
 * Check if cookie consent form is in viewport.
 */
let CcInViewport = () => ccm.has_banner();

export {StyleCCBar, AllowCookie, GetPermissions, CcInViewport, ShowCC};
